import React, { useContext, useState } from 'react';
import ArrowLeft from '../../../../../Assets/Arrow left.svg';
import Cross from '../../../../../Assets/Modals/closeIcon.svg';
import ImageAdd from '../../../../../Assets/Add image.svg';
import { useDispatch, useSelector } from 'react-redux';
import { clearImages, closeModal, setImages, setModal } from '../../../../../Features/lensSlice';
import { v4 as uuidv4 } from 'uuid';
import { ImageContext } from '../../../../../Context/ImagesContext';

function Input() {
    const dispatch = useDispatch();

    const [error, setError] = useState('');

    const images = useSelector((state) => state.lens.media.images);

    const { setImagesList } = useContext(ImageContext);

    const handlePreviousClick = () => {
        dispatch(setModal('create'));
        dispatch(clearImages());
    }

    const handleCloseModal = () => {
        dispatch(closeModal());
        dispatch(clearImages());
    }

    const handleImageSelection = async (e) => {
        const files = Array.from(e.target.files);
        processFiles(files);
    };

    const processFiles = (files) => {
        if (images.length + files.length <= 10) {
            const selectedImages = files.map(file => ({
                id: uuidv4(),
                url: URL.createObjectURL(file),
                file: file,
            }));

            setImagesList(selectedImages);

            const imagesToSend = selectedImages.map(image => ({
                id: image.id,
                url: image.url
            }));

            dispatch(setImages([...imagesToSend]));
        } else {
            setError('Max 10 images');
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);
        processFiles(files);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    return (
        <div className="w-2/5 relative flex flex-col h-full p-4">
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <button onClick={handlePreviousClick} className="w-11 h-11 flex items-center justify-center">
                        <img src={ArrowLeft} alt="" />
                    </button>

                    <h1 className='font-semibold text-2xl text-[#121212]'>Default Post</h1>
                </div>

                <button onClick={handleCloseModal} className="w-11 h-11 flex items-center justify-center">
                    <img src={Cross} alt="" />
                </button>
            </div>

            <div 
                className="flex gap-6 mt-48" 
                onDrop={handleDrop} 
                onDragOver={handleDragOver} 
                onDragLeave={handleDragLeave} 
            >
                <label htmlFor='image-input' className="m-0 cursor-pointer flex flex-col items-center justify-center gap-[10px] w-full h-[140px] bg-[#E5E5E5] px-5 py-[10px] border-2 border-dashed border-[#D1D5DB] rounded-lg">
                    <div className="w-12 h-12 flex justify-center items-center">
                        <img src={ImageAdd} alt="" />
                    </div>

                    {
                        error.length ? 
                        <p className='w-4/5 text-center font-urbanist-regular font-medium text-sm text-[#ef4444e9]'>*{error}</p> : 
                        <p className='w-1/4 text-center font-urbanist-regular font-medium text-sm text-[#4B5563]'>
                            <span className='text-[#4F46E5]'>Click to Upload</span> or Drag or drop
                        </p>
                    }
                </label>

                <input 
                    className='hidden' 
                    id='image-input' 
                    type="file" 
                    accept="image/*" 
                    multiple
                    onChange={handleImageSelection}
                />
            </div>
        </div>
    );
}

export default Input;
